<!-- login-page.component.html -->
<div class="login-container">
  <div class="login-card">
      
    <!-- Updated Header with white background -->
    <div class="landing-header">
      <button
        class="back-button"
        routerLink="/"
        title="Back to Landing Page"
      >
        <i class="bi bi-arrow-left"></i>
      </button>
      <img
        src="./../../../../../assets/images/pmi_small.jpg"
        alt="Company Logo"
        class="login-logo"
      />
      <h2 class="landing-title">PMI Synthetic Test Data Generation</h2>
      <p class="landing-subtitle">Powered by GenAI</p>
      <!-- <a href="https://public-alb-stdg-dev-27471541.eu-west-1.elb.amazonaws.com/" class="note-link">
        <p class="landing-note">Note: Our backend uses HTTP. If blocked, click "Advanced" in your browser's security warning to proceed.</p>
      </a> -->
    </div>

    <!-- Content - keep the same -->
    <div class="login-content">
      <div class="row g-3">
        <!-- Form Column -->
        <div class="col-lg-12">
          <div class="auth-wrapper">
            <h3 class="auth-title">Login using Single Sign-On</h3>
            
            <form class="auth-form">
              <!-- Node Selection -->
              <div class="form-group">
                <label for="nodeSelect" class="form-label">Node</label>
                <select 
                  id="nodeSelect"
                  class="form-select"
                  [(ngModel)]="selectedNode" 
                  (change)="onNodeSelect($event)" 
                  name="nodeselect"
                  required
                >
                  <option value="" disabled selected>Select Node</option>
                  <option value="SUST">SUST Node</option>
                  <option value="FCD">FCD Node</option>
                  <option value="FCT">FCT Node</option>
                </select>
              </div>

              <!-- Environment Selection -->
              <div class="form-group">
                <label for="envSelect" class="form-label">Environment</label>
                <select 
                  id="envSelect"
                  class="form-select"
                  [(ngModel)]="selectedEnv" 
                  name="envselect"
                  required
                >
                  <option value="" disabled selected>Select Environment</option>
                  <option value="DEV">DEV</option>
                  <option value="QAS">QAS</option>
                </select>
              </div>

              <!-- Login Button -->
              <button 
                type="button" 
                class="btn btn-primary auth-button"
                (click)="loginRedirect()"
              >
                <i class="bi bi-shield-lock-fill"></i>
                Continue with SSO
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast Container -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100">
    <ngb-toast
      *ngFor="let toast of toastService.getToasts()"
      [autohide]="toast.options?.autohide ?? true"
      [delay]="toast.options?.delay ?? 5000"
      [class]="toast.options?.classname"
      (hidden)="toastService.remove(toast)"
    >
    </ngb-toast>
  </div>
</div>

<router-outlet></router-outlet>